export default "__VITE_ASSET___ao_07QO__"